import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "../../styles/ResetPasswordPage.css";

const ResetPasswordPage = () => {
  const { userType, id, token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [tokenValid, setTokenValid] = useState(null); // null = checking, true/false
  const navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_API_URL || "https://pumotechnovationcrm.com";

  // Verify token when page loads
 useEffect(() => {
  const verifyToken = async () => {
    try {
      console.log("Verifying:", { userType, id, token });
      const url = `${apiUrl}/password/verify/${userType}/${id}/${token}`;
      console.log("Verify URL:", url);
      await axios.get(url);
      setTokenValid(true);
    } catch (error) {
      console.error("Verify failed:", error?.response?.data || error.message);
      setTokenValid(false);
    }
  };
  verifyToken();
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("userType:", userType, "id:", id, "token:", token);

    if (!userType || !id || !token) {
      alert("Invalid reset link.");
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/password/reset`, {
        userType,
        id,
        token,
        newPassword,
      });

      alert(response.data.message || "Password reset successful!");
      navigate("/");
    } catch (error) {
      console.error("Reset Password Error:", error);
      alert(error?.response?.data?.message || "Something went wrong!");
    }
  };

  // Show loading while verifying
  if (tokenValid === null) {
    return <div style={{ textAlign: "center", marginTop: "50px" }}>Verifying reset link...</div>;
  }

  // Show error if token invalid/expired
  if (tokenValid === false) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h3>❌ This reset link is invalid or has expired.</h3>
        <button onClick={() => navigate("/forgot-password")}>Request New Link</button>
      </div>
    );
  }

  return (
    <div className="reset-password-container">
      <div className="reset-password-card">
        <h2 className="reset-password-title">Reset Your Password</h2>
        <form className="reset-password-form" onSubmit={handleSubmit}>
          <label className="reset-password-label">New Password:</label>
          <input
            className="reset-password-input"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter your new password"
            required
          />
          <button className="reset-password-button" type="submit">
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;